// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "theme" + "-4.58.0.css?" + __webpack_require__.h().slice(0, 6) + "";
};